import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AddState, State } from '../models/state/state';


@Injectable({
  providedIn: 'root'
})
export class StateService {

  constructor(
    private _http: HttpClient
  ) { }

    public getStates(StateId?: number): Observable<State[]>{
        return this._http.get<State[]>(`${environment.api.url}/States?StatesId=${StateId??''}`);
    }
  
    public deleteState(StateId: number): Observable<boolean> {
        return this._http.delete<any>(`${environment.api.url}/States/${StateId}`);
    }
  
    public addState(model: AddState): Observable<boolean> {
        return this._http.post<any>(`${environment.api.url}/States`, model);
    }
}
